const LOCK_SCROLL_CLASS = 'js-lock-scroll';

export function lockScroll() {
  const isAlreadyLocked = document.body.classList.contains(LOCK_SCROLL_CLASS);
  if (isAlreadyLocked) return;

  keepScrollYPosition();
  document.body.classList.add(LOCK_SCROLL_CLASS);
}

function keepScrollYPosition() {
  const scrollY = `-${window.scrollY}px`;
  document.body.style.top = scrollY;
}

export function unlockScroll() {
  scrollToOldScrollYPosition();
  document.body.classList.remove(LOCK_SCROLL_CLASS);
}

function scrollToOldScrollYPosition() {
  const scrollY = document.body.style.top;
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
}

export function toggleLockScroll() {
  if (document.body.classList.contains(LOCK_SCROLL_CLASS)) {
    unlockScroll();
  } else {
    lockScroll();
  }
}
